import { EllipsisHorizontalIcon } from '@heroicons/react/16/solid';
import { useState } from 'react';

import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownMenu,
} from '@/components/ui/catalyst/dropdown';

interface MedicalProviderTasksDropdownProps {
  noteId?: string;
  createTasks?: () => Promise<void>;
}

export const MedicalProviderTasksDropdown: React.FC<
  MedicalProviderTasksDropdownProps
> = ({ noteId, createTasks }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleCreateRecordRequest = async () => {
    if (!createTasks) return;

    try {
      setIsSubmitting(true);
      await createTasks();
    } catch (error) {
      console.error('Failed to create record request:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dropdown>
      <DropdownButton plain aria-label="Medical provider actions">
        <EllipsisHorizontalIcon className="h-5 w-5" />
      </DropdownButton>
      <DropdownMenu>
        <DropdownItem
          onClick={handleCreateRecordRequest}
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Creating...' : 'Create Record Request'}
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};
